export default "__VITE_ASSET__4deae6dc__"